import type { AllowedLanguages } from "@/types/generic";

export const niches = [
  {
    value: "Construct",
    label: { nl: "Construct", fr: "Construct", en: "Construct" },
    color: "text-orange",
  },
  {
    value: "Construct bedienden",
    label: {
      nl: "Technics Bedienden",
      fr: "Technics employés",
      en: "Technics Employees",
    },
    color: "text-blue",
  },
  {
    value: "Interim",
    label: { nl: "Interim", fr: "Interim", en: "Interim" },
    color: "text-yellow",
  },
  {
    value: "Office",
    label: { nl: "Office", fr: "Office", en: "Office" },
    color: "text-orange",
  },
  {
    value: "Finance",
    label: { nl: "Finance", fr: "Finance", en: "Finance" },
    color: "text-purple",
  },
  {
    value: "Technics",
    label: { nl: "Technics", fr: "Technics", en: "Technics" },
    color: "text-black-400",
  },
  {
    value: "Chauffeurs",
    label: { nl: "Chauffeurs", fr: "Chauffeurs", en: "Chauffeurs" },
    color: "text-green",
  },
];

export function getNicheColor(niche: string) {
  const nicheObj = niches.find((n) => n.value === niche);

  return nicheObj?.color;
}

export function getNicheLabel(niche: string, locale: AllowedLanguages) {
  const nicheObj = niches.find((n) => n.value === niche);
  return nicheObj?.label[locale];
}
